import React from 'react';
import { 
  FaSearch, 
  FaBriefcase, 
  FaBuilding, 
  FaMobileAlt, 
  FaShieldAlt,
  FaBell 
} from 'react-icons/fa';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: <FaSearch />,
      title: 'Smart Job Search',
      description: 'Advanced filters by category, job type, location, and skills. Find exactly what you\'re looking for.'
    },
    {
      icon: <FaBriefcase />,
      title: 'Multiple Job Types',
      description: 'Full-time, part-time, internships, and contract positions. Something for everyone.'
    },
    {
      icon: <FaBuilding />,
      title: 'Company Profiles',
      description: 'Companies can showcase their culture, benefits, and opportunities. Build your employer brand.'
    },
    {
      icon: <FaMobileAlt />,
      title: 'Mobile First',
      description: 'Beautiful, responsive design that works perfectly on all devices. Apply on the go.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Secure & Safe',
      description: 'Your data is protected with industry-standard security. Privacy is our priority.'
    },
    {
      icon: <FaBell />,
      title: 'Job Alerts',
      description: 'Get notified about new opportunities matching your profile. Never miss a chance.'
    }
  ];

  return (
    <section id="features" className="features">
      <div className="features-container">
        <div className="section-header">
          <h2 className="section-title">App Features</h2>
          <p className="section-description">
            Powerful features designed for mobile job searching and career growth
          </p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;

